import { TaskListItemDto } from "../../services/client";
import { useInfiniteQuery } from "@tanstack/react-query";
import { predictionsGetTasksInfiniteOptions } from "../../services/client/@tanstack/react-query.gen";
import { ListTasks } from "./ListTask";
import { FETCH_PAGE_SIZE } from "../../hooks/useCursorPagination";

export type ListTasksProps = {
  site_id: string;
  className?: string;
  getDetailsUrl?: (record: TaskListItemDto) => string;
};

export const ListPredictionTasks: React.FC<ListTasksProps> = ({
  site_id,
  className,
  getDetailsUrl,
}) => {
  const {
    isLoading,
    data: tasks,
    error,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
  } = useInfiniteQuery({
    ...predictionsGetTasksInfiniteOptions({
      path: { site_id: site_id },
      query: { page_size: FETCH_PAGE_SIZE },
    }),
    getNextPageParam: (lastPage) => lastPage.end_cursor,
    enabled: !!site_id,
  });

  return (
    <ListTasks
      pages={tasks?.pages}
      error={error != null}
      isLoading={isLoading}
      className={className}
      getDetailsUrl={getDetailsUrl}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      paramKey="predictions_page"
    />
  );
};
